import React from "react";
import { useLocation } from "react-router-dom";

const PaymentSuccess = () => {
  const location = useLocation();
  const Orderdata = new URLSearchParams(location.search).get("orderid");
  const totalamt = new URLSearchParams(location.search).get("totalamt");
  if (!Orderdata && !totalamt) {
    window.location.href = "/";
  }
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ height: "50vh" }}
    >
      <h2>Payment Successful!</h2>
      <p>Your order has been successfully processed.</p>
    </div>
  );
};

export default PaymentSuccess;
